export default {
  data () {
    let remarkTemplates = [
      {name: 'New Patient', text: 'Please register new patient with your passport at registration counter first,then queue will be arranged once arrived. First come first serve. Apologise in advance for any inconvenience . Thank you'},
      {name: 'ประวัติใหม่', text: 'เนื่องจากท่านเป็นประวัติใหม่ กรุณาติดต่อแผนกเวชระเบียนเพื่อทำประวัติด้วยบัตรประชาชน และรับคิวที่แผนกอีกครั้ง พยาบาลจะลำดับคิวให้ท่านอีกครั้งเมื่อไปถึง มาก่อนได้ตรวจก่อน ขอบคุณค่ะ'}
    ]
    return {
      remarkTemplates: remarkTemplates
    }
  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/pages/appointment/appointment_mixin.js